import React from "react";
import styled from "styled-components";
import colors from "../constatns/colors";
import useWindowDimensions from "../constatns/size";
import { AiFillLinkedin } from "react-icons/ai";

import "../styles/home.css";
function TeamCard({image, title, description, href, isColorBorder}) {
    const { width, height } = useWindowDimensions();
  return (
    <Container width={width} height={height} id="eccosystem">
        <MyHref href={href} >
            {
                isColorBorder ? <ColoredBorder color={((1<<24)*Math.random() | 0).toString(16)} />:
                <CardImage height={height} alt={image} src={require("../assets/images/gear_box.png")} />
                // <CardImage height={height} alt={image} src={require("../assets/images/gear.jpeg")} />
            }
            <InnerContainer width={width} >
                <h2 style={{color: colors.white, margin: 10, fontWeight: 500}}>{title}</h2>
                <Description>{description} {href && <AiFillLinkedin style={{color: "#0077b5", marginBottom: -2}} />}</Description>
            </InnerContainer>
        </MyHref>
            
    </Container>
  );
}

const Container = styled.div`
    padding-top: 20px;
`

const InnerContainer = styled.div`
    width: ${({width})=> width * 0.2}px;
    @media (max-width: 768px) {
        width: ${({width})=> width * 2}px;
    }
`

const ColoredBorder = styled.div`
    background-color: #${({color})=> color};
    width: 3px;
    height: 50px;
    margin-top: 15px;
    border-radius: 3px;
`

const MyHref = styled.a`
    display: flex;
    text-decoration: none;
`

const CardImage = styled.img`
    width: ${({width})=> width * 0.08}px;
    height: ${({height})=> height * 0.08}px;
    margin-top: ${({width})=> width * 0.02}px;
    @media (max-width: 1440px) {
        margin-top: ${({height})=> height * 0.02}px;
    }
    
`

const Description = styled.a`
    color: ${colors.grey};
    text-align: center;
    font-size: 18px;
    margin-left: 10px;
`

export default TeamCard;
